import { AuthenticationRepository } from "../../../domain/authentication/AuthenticationRepository";
import AuthenticationDataSource from "../../../infrastructure/datasource/authentication/AuthenticationDataSource";

class LogoutResKa {
  private readonly repository: AuthenticationRepository = new AuthenticationDataSource();

  public execute() {
    this.repository.logout();
  }
}

export default LogoutResKa;
